/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Fairuse_Meta_Title1Inputs */

const id_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kebijakan Penggunaan Wajar - egdata.app`)
};

const ms_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dasar Penggunaan Adil - egdata.app`)
};

const da_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fair Use Politik - egdata.app`)
};

const de_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fair-Use-Richtlinie - egdata.app`)
};

const en_us2_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fair Use Policy - egdata.app`)
};

const es_es2_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de uso justo - egdata.app`)
};

const es_mx2_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de uso justo - egdata.app`)
};

const fil_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patakaran sa Patas na Paggamit - egdata.app`)
};

const fr_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politique d'utilisation équitable - egdata.app`)
};

const it_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politica di Fair Use - egdata.app`)
};

const hu_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fair Use irányelv - egdata.app`)
};

const nl_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fair Use-beleid - egdata.app`)
};

const no_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retningslinjer for rimelig bruk - egdata.app`)
};

const pl_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polityka dozwolonego użytku - egdata.app`)
};

const pt_br2_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de uso justo - egdata.app`)
};

const pt_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de Uso Justo - egdata.app`)
};

const ro_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politica de utilizare corectă - egdata.app`)
};

const fi_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kohtuullisen käytön käytäntö - egdata.app`)
};

const sv_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Policy för skälig användning - egdata.app`)
};

const vi_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chính sách sử dụng hợp lý - egdata.app`)
};

const tr_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adil Kullanım Politikası - egdata.app`)
};

const cs_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zásady spravedlivého použití - egdata.app`)
};

const bg_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Политика за честна употреба - egdata.app`)
};

const ru_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Политика добросовестного использования — egdata.app`)
};

const uk_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Політика добросовісного використання - egdata.app`)
};

const ar_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سياسة الاستخدام العادل - egdata.app`)
};

const hi_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उचित उपयोग नीति - egdata.app`)
};

const th_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นโยบายการใช้งานโดยชอบ - egdata.app`)
};

const ja_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フェアユースポリシー - egdata.app`)
};

const zh_cn2_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合理使用政策 - egdata.app`)
};

const zh_hant1_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合理使用政策 - egdata.app`)
};

const ko_misc_fairuse_meta_title1 = /** @type {(inputs: Misc_Fairuse_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공정 사용 정책 - egdata.app`)
};

/**
* | output |
* | --- |
* | "Fair Use Policy - egdata.app" |
*
* @param {Misc_Fairuse_Meta_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_fairuse_meta_title1 = /** @type {((inputs?: Misc_Fairuse_Meta_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Fairuse_Meta_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_fairuse_meta_title1(inputs)
	if (locale === "ms") return ms_misc_fairuse_meta_title1(inputs)
	if (locale === "da") return da_misc_fairuse_meta_title1(inputs)
	if (locale === "de") return de_misc_fairuse_meta_title1(inputs)
	if (locale === "en-US") return en_us2_misc_fairuse_meta_title1(inputs)
	if (locale === "es-ES") return es_es2_misc_fairuse_meta_title1(inputs)
	if (locale === "es-MX") return es_mx2_misc_fairuse_meta_title1(inputs)
	if (locale === "fil") return fil_misc_fairuse_meta_title1(inputs)
	if (locale === "fr") return fr_misc_fairuse_meta_title1(inputs)
	if (locale === "it") return it_misc_fairuse_meta_title1(inputs)
	if (locale === "hu") return hu_misc_fairuse_meta_title1(inputs)
	if (locale === "nl") return nl_misc_fairuse_meta_title1(inputs)
	if (locale === "no") return no_misc_fairuse_meta_title1(inputs)
	if (locale === "pl") return pl_misc_fairuse_meta_title1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_fairuse_meta_title1(inputs)
	if (locale === "pt") return pt_misc_fairuse_meta_title1(inputs)
	if (locale === "ro") return ro_misc_fairuse_meta_title1(inputs)
	if (locale === "fi") return fi_misc_fairuse_meta_title1(inputs)
	if (locale === "sv") return sv_misc_fairuse_meta_title1(inputs)
	if (locale === "vi") return vi_misc_fairuse_meta_title1(inputs)
	if (locale === "tr") return tr_misc_fairuse_meta_title1(inputs)
	if (locale === "cs") return cs_misc_fairuse_meta_title1(inputs)
	if (locale === "bg") return bg_misc_fairuse_meta_title1(inputs)
	if (locale === "ru") return ru_misc_fairuse_meta_title1(inputs)
	if (locale === "uk") return uk_misc_fairuse_meta_title1(inputs)
	if (locale === "ar") return ar_misc_fairuse_meta_title1(inputs)
	if (locale === "hi") return hi_misc_fairuse_meta_title1(inputs)
	if (locale === "th") return th_misc_fairuse_meta_title1(inputs)
	if (locale === "ja") return ja_misc_fairuse_meta_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_fairuse_meta_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_fairuse_meta_title1(inputs)
	return ko_misc_fairuse_meta_title1(inputs)
});
export { misc_fairuse_meta_title1 as "misc.fairUse.meta.title" }